// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tlsoneepefqekbwknprq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRsc29uZWVwZWZxZWtid2tucHJxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI0NzY5MzQsImV4cCI6MjA1ODA1MjkzNH0.YczZqdRO7CeiyFqaoK7Gwbn8GsBCEijgChp5b4hFCx8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);